import { render, staticRenderFns } from "./product-detail-hero.vue?vue&type=template&id=eb826478&"
import script from "./product-detail-hero.vue?vue&type=script&lang=js&"
export * from "./product-detail-hero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports